export default class Locale_MailTemplates { 
	MailTemplate: string = "Mail Templare";
	MailTemplateDescription: string = "Mail Template Description";
}